import { Button, Icons, Label } from "@sede-x/shell-ds-react-framework";
import {
  RadioButtonSelected,
  RadioButtonUnselected
} from "@sede-x/shell-ds-react-framework/build/esm/components/Icon/components";
import { format } from "date-fns";
import { useCallback, useContext, useState } from "react";
import { TMovement, TMovementGroup } from "ticketing/ticketing.types";
import { equalsIgnoreCase } from "ticketing/utils";
import MovementAdditionalDetailsContainer from "./MovementAdditionalDetailsContainer";
import { MovementChildDetails } from "./MovementChildDetails";
import { MovementChildHeader } from "./MovementChildGroupHeader";
import "./movements.css";
import { MovementsMainContext } from "./utils";
export const MovementDetails = ({
  movement,
  movementGroup,
  activeMovementGroup,
  isActiveMovement
}: {
  movement: TMovement;
  movementGroup: TMovementGroup;
  activeMovementGroup: TMovementGroup | null;
  isActiveMovement: boolean;
}) => {
  const { onActiveMovementGroupChanged } = useContext(MovementsMainContext);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(false);
  const [showChildren, setShowChildren] = useState(false);
  const radarAlert = "Radar Alert";
  const hasAlerts = movement.alerts.some(alert => !equalsIgnoreCase(alert.code, radarAlert));
  const hasChildren = (movement.children?.length ?? 0) > 0;

  const onActiveMovementChanged = useCallback(
    (aMovement: TMovement) => {
      if (activeMovementGroup?.activeMovement.id === aMovement.id) {
        if (activeMovementGroup.activeChild) {
          return onActiveMovementGroupChanged?.({
            ...movementGroup,
            activeChild: null
          });
        }
        return onActiveMovementGroupChanged?.(null);
      }

      return onActiveMovementGroupChanged?.({
        ...movementGroup,
        activeMovement: aMovement
      });
    },
    [
      movementGroup,
      activeMovementGroup?.activeMovement.id,
      activeMovementGroup?.activeChild,
      onActiveMovementGroupChanged
    ]
  );

  const onActiveChildChanged = (child: Partial<TMovement>) => {
    onActiveMovementGroupChanged?.({
      ...movementGroup,
      activeMovement: movement,
      activeChild:
        activeMovementGroup === movementGroup && movementGroup.activeChild === child
          ? null
          : child
    });
  };

  const handleShowChildren = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (
      showChildren &&
      activeMovementGroup?.activeMovement.id === movement.id &&
      activeMovementGroup.activeChild
    ) {
      onActiveMovementGroupChanged?.({
        ...movementGroup,
        activeChild: null
      });
    }
    setShowChildren(!showChildren);
    event?.stopPropagation();
  };
 
  //CheckboxUnselected
  return (
    <>
      <div
        className={`movement-detail-container ${hasAlerts ? 'has-alerts' : ''}`}
        role="none"
        onClick={e => {
          onActiveMovementChanged(movement);
          e.stopPropagation();
        }}
        >
        {isActiveMovement && activeMovementGroup?.activeChild == null ? (
          <RadioButtonSelected style={{ width: "100%", height: "100%" }} fill="#ffc600" />
        ) : (
          <RadioButtonUnselected style={{ width: "100%", height: "100%" }} fill="#dddddc" />
        )}

        <Label style={{ color: "black" }} className="detail-label">
          {format(new Date(movement.startDate), "yyyy-MM-dd")}
        </Label>
        <Label style={{ color: "black" }} className="detail-label">
          {movement.product?.name}
        </Label>
        <Label style={{ color: "black" }} className="prefix-text">
          at
        </Label>
        <Label style={{ color: "black" }} className="detail-label-wide">
          {movement.titleTransferFacility?.name}
        </Label>
        <Label style={{ color: "black" }} className="prefix-text">
          Via
        </Label>
        <Label style={{ color: "black" }} className="detail-label">
          {movement.activityType?.name}
        </Label>
        <Label style={{ color: "black" }} className="prefix-text">
          From
        </Label>
        <Label style={{ color: "black" }} className="detail-label-narrow">
          {movement.recDeal?.contractNumber}
        </Label>
        <Label style={{ color: "black" }} className="prefix-text">
          To
        </Label>
        <Label style={{ color: "black" }} className="detail-label-narrow">
          {movement.delDeal?.contractNumber}
        </Label>
        <Label style={{ color: "black" }} className="detail-label">
          {movement.incoterm?.name}
        </Label>
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {hasChildren && (
            <Button
              size="small"
              icon={showChildren ? <Icons.MinusCircle /> : <Icons.AddCircle />}
              className="movement-toggle-button" // Apply the new class
              onClick={handleShowChildren}></Button>
          )}

          <Button
            size="small"
            className="movement-info-button" // Apply the new class
            icon={<Icons.InfoCircle style={{fill: "blue"}}/>}
            onClick={e => {
              setShowAdditionalDetails(true);
              e.stopPropagation();
            }}></Button>
        </div>
      </div>
      {showAdditionalDetails && (
        <MovementAdditionalDetailsContainer
          movement={movement}
          onClose={() => setShowAdditionalDetails(false)}></MovementAdditionalDetailsContainer>
      )}
      {showChildren &&
        movement.children
          ?.sort((child1, child2) =>
            (child1.enterpriseSystemCode ?? "").localeCompare(child2.enterpriseSystemCode ?? "")
          )
          ?.map(child => (
            <div
              style={{ margin: "8px 0 2px 24px" }}
              className="movement-grp-wrapper"
              key={child.id}>
              <MovementChildHeader childMovement={child} />
              <MovementChildDetails
                childMovement={child}
                isActiveChild={activeMovementGroup?.activeChild === child}
                onActiveChildChanged={onActiveChildChanged}
              />
            </div>
          ))}
    </>
  );
};
